module.exports = __webpack_public_path__ + "img/27.e47743c5.jpg";